import { NgClass } from "@angular/common";
import {
    AfterViewInit,
    Component,
    EventEmitter,
    forwardRef,
    HostBinding,
    Input,
    OnInit,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Observable } from "rxjs";
import { RequiredDirective } from "../../directives/required/required.directive";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { HelpiconComponent } from "../helpicon/helpicon.component";
import { InfoComponent } from "../info/info.component";
import { IRadiobuttonItem } from "./radiobutton/IRadiobuttonItem";
import { RadiobuttonComponent } from "./radiobutton/radiobutton.component";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadiobuttonGroupComponent)
        }
    ],
    selector: "rask-radiobutton-group",
    styleUrls: ["./radiobuttongroup.component.scss"],
    templateUrl: "./radiobuttongroup.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RequiredDirective,
        InfoComponent,
        HelpiconComponent,
        RadiobuttonComponent,
        NgClass,
        ValidationMessageComponent
    ]
})
export class RadiobuttonGroupComponent extends ControlValueAccessorBaseComponent implements OnInit, AfterViewInit {
    @Input() buttons: IRadiobuttonItem[];
    @Input() helpUrl: string;
    @Input() negative?: boolean;
    @Input() onBeforeChange: ($event: any) => Observable<boolean>;
    @Output() checkedchanged = new EventEmitter<IRadiobuttonItem>();
    @HostBinding("class.vertical") @Input() verticalLayout?: boolean = false;
    @HostBinding("class.small") @Input() small?: boolean = false;
    changed(key: any): void {
        this.value = key;
        this.checkedchanged.emit(key);
    }

    ngOnInit() {
        super.ngOnInit();
        this.negative = this.emptyIsTrue(this.negative);
    }
}
